<template>

  <svg class="svg-node"><!-- 六边形 -->
    <g transform="translate(0.5,0.5)" style="visibility: visible">
      <polygon
        points="6.16,0 21.84,0 28,14 21.84,28 6.16,28 0,14"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="1.3"
        pointer-events="all"
      ></polygon>
    </g>
  </svg>
</template>

<script>
export default {
}
</script>